import type { CreateQueryResult } from '@tanstack/svelte-query'

export function queryReactiveAccessor<QueryDataType, T>(
  query: CreateQueryResult<QueryDataType>,
  accessor: (data?: QueryDataType) => T,
): () => T
export function queryReactiveAccessor<QueryDataType>(
  query: CreateQueryResult<QueryDataType>,
): () => QueryDataType | undefined
export function queryReactiveAccessor<QueryDataType, T>(
  query: CreateQueryResult<QueryDataType>,
  accessor?: (data?: QueryDataType) => T,
): () => T | QueryDataType | undefined {
  return () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    query.dataUpdatedAt

    if (typeof accessor === 'function') {
      return accessor(query.data)
    }
    return query.data
  }
}
